import React from "react";

const Java_Interface = () => {
  return (
    <div>
      <h1>Java Interface</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Interface in Java.</p>
    </div>
  );
};

export default Java_Interface;
